<div class="g-layout__container">
    <!-- Page Header -->
    <div class="approvals-header">
        <div class="header-title">
            <i class="fa-solid fa-clipboard-check"></i>
            <span>{{ 'DepartmentApprovals' | navTitle | async }}</span>
        </div>
        <p class="header-subtitle">{{"review_and_approve_projects"|translate}}</p>
    </div>
    
    <div class="br"></div>

    <!-- Projects Table -->
    @if(pendingProjects.length > 0 || currentPage > 1) {
    <div class="projects-table-container">
        <p-table [value]="pendingProjects" 
                 [dir]="dir"
                 styleClass="approvals-table"
                 [paginator]="false">
            
            <ng-template pTemplate="header">
                <tr>
                    <th>#</th>
                    <th>{{'project_name' | translate}}</th>
                    <th>{{'submitted_by' | translate}}</th>
                    <th>{{'submission_date' | translate}}</th>
                    <th>{{'status' | translate}}</th>
                    <th class="text-center">{{'actions' | translate}}</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-project let-rowIndex="rowIndex">
                <tr>
                    <td>{{(currentPage - 1) * pageSize + rowIndex + 1}}</td>
                    <td>
                        <div class="project-name">
                            <i class="fa-solid fa-rocket"></i>
                            <span>{{project.name}}</span>
                        </div>
                    </td>
                    <td>{{project.in_charge_name}}</td>
                    <td>{{project.created_at | date:'dd/MM/yyyy HH:mm'}}</td>
                    <td>
                        <p-tag severity="warning" value="{{'pending_your_approval' | translate}}" />
                    </td>
                    <td class="text-center">
                        <div class="action-icons">
                            <button pButton 
                                    class="p-button-rounded p-button-text preview-icon-btn"
                                    icon="fa-solid fa-eye"
                                    (click)="openPreviewDialog(project)"
                                    [pTooltip]="dir === 'rtl' ? 'معاينة وقرار' : 'Preview & Decide'">
                            </button>
                            <button pButton 
                                    class="p-button-rounded p-button-text view-icon-btn"
                                    icon="fa-solid fa-arrow-up-right-from-square"
                                    [routerLink]="['/strategies', project.strategic_plan_id, 'projects', project.id]"
                                    [pTooltip]="dir === 'rtl' ? 'عرض التفاصيل' : 'View Details'">
                            </button>
                        </div>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="6" class="text-center empty-message">
                        <i class="fa-solid fa-inbox"></i>
                        <p>{{'no_pending_approvals' | translate}}</p>
                    </td>
                </tr>
            </ng-template>
        </p-table>
        
        <!-- Custom Server-Side Pagination -->
        @if(totalPages > 1) {
        <div class="pagination-container" [dir]="dir">
            <div class="pagination-info">
                <span>
                    {{ dir === 'rtl' 
                        ? 'عرض ' + ((currentPage - 1) * pageSize + 1) + ' إلى ' + Math.min(currentPage * pageSize, totalCount) + ' من ' + totalCount + ' مبادرة'
                        : 'Showing ' + ((currentPage - 1) * pageSize + 1) + ' to ' + Math.min(currentPage * pageSize, totalCount) + ' of ' + totalCount + ' projects' }}
                </span>
            </div>
            <div class="pagination-controls">
                <button pButton 
                        class="p-button-text p-button-sm"
                        icon="fa-solid fa-angles-left"
                        [disabled]="currentPage === 1"
                        (click)="onPageChange(1)"
                        [pTooltip]="dir === 'rtl' ? 'الصفحة الأولى' : 'First Page'">
                </button>
                <button pButton 
                        class="p-button-text p-button-sm"
                        icon="fa-solid fa-chevron-left"
                        [disabled]="currentPage === 1"
                        (click)="onPageChange(currentPage - 1)"
                        [pTooltip]="dir === 'rtl' ? 'السابق' : 'Previous'">
                </button>
                <span class="page-number">
                    {{ dir === 'rtl' 
                        ? 'صفحة ' + currentPage + ' من ' + totalPages
                        : 'Page ' + currentPage + ' of ' + totalPages }}
                </span>
                <button pButton 
                        class="p-button-text p-button-sm"
                        icon="fa-solid fa-chevron-right"
                        [disabled]="currentPage === totalPages"
                        (click)="onPageChange(currentPage + 1)"
                        [pTooltip]="dir === 'rtl' ? 'التالي' : 'Next'">
                </button>
                <button pButton 
                        class="p-button-text p-button-sm"
                        icon="fa-solid fa-angles-right"
                        [disabled]="currentPage === totalPages"
                        (click)="onPageChange(totalPages)"
                        [pTooltip]="dir === 'rtl' ? 'الصفحة الأخيرة' : 'Last Page'">
                </button>
            </div>
        </div>
        }
    </div>
    }
    @else {
    <div class="empty-state">
        <i class="fa-solid fa-inbox"></i>
        <h3>{{'no_pending_approvals' | translate}}</h3>
        <p>{{'all_projects_reviewed' | translate}}</p>
    </div>
    }

    <!-- Preview Dialog -->
    <p-dialog [(visible)]="showApprovalDialog"
              [modal]="true"
              [showHeader]="false"
              [style]="{width: '650px'}"
              [dir]="dir"
              styleClass="preview-modal">
        
        <div class="modal-custom-header">
            <h3>
                <i class="fa-solid fa-eye"></i>
                {{dir === 'rtl' ? 'معاينة المبادرة' : 'Preview Project'}}
            </h3>
            <button class="close-modal-btn" 
                    (click)="showApprovalDialog = false"
                    [disabled]="isProcessing">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>

        <div class="dialog-content">
            <div class="info-card">
                <div class="info-item">
                    <div class="info-label">
                        <i class="fa-solid fa-rocket"></i>
                        {{'project_name' | translate}}
                    </div>
                    <div class="info-value">{{selectedProject?.name}}</div>
                </div>
                
                <div class="info-row">
                    <div class="info-item">
                        <div class="info-label">
                            <i class="fa-solid fa-user"></i>
                            {{'submitted_by' | translate}}
                        </div>
                        <div class="info-value">{{selectedProject?.in_charge_name}}</div>
                    </div>
                    
                    <div class="info-item">
                        <div class="info-label">
                            <i class="fa-solid fa-calendar"></i>
                            {{'submission_date' | translate}}
                        </div>
                        <div class="info-value">{{selectedProject?.created_at | date:'dd/MM/yyyy HH:mm'}}</div>
                    </div>
                </div>
            </div>

            <div class="note-section">
                <label for="note">
                    <i class="fa-solid fa-note-sticky"></i>
                    {{'note' | translate}}
                    <span class="optional">({{ 'optional' | translate }})</span>
                </label>
                <textarea pInputTextarea 
                          id="note"
                          [(ngModel)]="approvalNote"
                          [rows]="5"
                          [placeholder]="dir === 'rtl' ? 'أدخل ملاحظة اختيارية...' : 'Enter optional note...'">
                </textarea>
            </div>
        </div>

        <ng-template pTemplate="footer">
            <div class="modal-footer-actions">
                <button pButton 
                        [label]="'reject' | translate"
                        icon="fa-solid fa-times"
                        class="reject-confirm-btn"
                        (click)="submitDecision(false)"
                        [loading]="isProcessing && !selectedProject?.willApprove"
                        [disabled]="isProcessing && selectedProject?.willApprove">
                </button>
                <button pButton 
                        [label]="'approve' | translate"
                        icon="fa-solid fa-check"
                        class="approve-confirm-btn"
                        (click)="submitDecision(true)"
                        [loading]="isProcessing && selectedProject?.willApprove"
                        [disabled]="isProcessing && !selectedProject?.willApprove">
                </button>
            </div>
        </ng-template>
    </p-dialog>
</div>




